export const buildSelectOptions = (items, labelKey, idKey, subItems, refId) => {
  const options = items.map((i) => {
    let label = i[labelKey];
    if (i[refId] !== '' && i[refId]) {
      label += ` (${i[refId]})`;
    }
    return {
      label: label,
      value: i[idKey],
      subItems: i[subItems]
    };
  });
  return options;
};

export const buildSelectOptionsIndex = (items) => {
  const options = items.map((i, index) => {
    return {
      label: i,
      value: index
    };
  });
  return options;
};
export const buildSelectOptionsString = (items) => {
  const options = items.map((i) => {
    return {
      label: i,
      value: i
    };
  });
  return options;
};

export const buildSelectItemsFromObject = (objectOptions) => {
  return Object.entries(objectOptions).map(([keyValue, value]) => ({
    label: value,
    value: keyValue
  }));
};

const alphabeticalCollator = new Intl.Collator('es', { sensitivity: 'base' });

export const compareAlphabetically = (a, b) => alphabeticalCollator.compare(String(a ?? ''), String(b ?? ''));

export const sortAlphabeticaly = (array, key = 'nombre') => {
  return [...(array ?? [])].sort((a, b) => compareAlphabetically(a[key], b[key]));
};
